import { Node_Type } from "./../ricos-schema/next-schema/index.js";
import { getHeadingAnchor } from "./../_shared/get-heading-anchor.js";
import { getTextFromNodes } from "./../_shared/get-text-from-nodes.js";
import { PmNodeType } from "./../_shared/pm-node-types.js";
function extractHeadingsFromPmDoc(doc, includedHeadings) {
  const headings = [];
  const includedLevels = new Set(includedHeadings);
  doc.descendants((currentNode) => {
    if (currentNode.type.name !== PmNodeType.HEADING) {
      return true;
    }
    const text = currentNode.textContent.trim();
    const level = Number(currentNode.attrs.level || 0);
    const nodeId = String(currentNode.attrs.id || "");
    if (!text || !nodeId || !includedLevels.has(level)) {
      return true;
    }
    headings.push({
      nodeId,
      text,
      level,
      anchor: getHeadingAnchor({ id: nodeId, text })
    });
    return true;
  });
  return headings;
}
function extractHeadingsFromRicosNodes(nodes, includedHeadings) {
  const headings = [];
  const included = new Set(includedHeadings);
  const visit = (currentNodes) => {
    currentNodes.forEach((currentNode) => {
      if (currentNode.type === Node_Type.HEADING) {
        const text = getTextFromNodes(currentNode.nodes).trim();
        const level = Number(currentNode.headingData?.level || 0);
        const nodeId = String(currentNode.id || "");
        if (text && nodeId && included.has(level)) {
          headings.push({
            nodeId,
            text,
            level,
            anchor: getHeadingAnchor({ id: nodeId, text })
          });
        }
      }
      if (Array.isArray(currentNode.nodes) && currentNode.nodes.length > 0) {
        visit(currentNode.nodes);
      }
    });
  };
  visit(nodes);
  return headings;
}
export {
  extractHeadingsFromPmDoc,
  extractHeadingsFromRicosNodes
};
//# sourceMappingURL=heading-extraction.js.map
